// Collection-card quick add: a round cart button at the bottom-right of the product image.
// Single-variant products add straight away; others open a pop-up to pick colour/size (the main image follows the colour).
// Adds go through the theme's own CartLinesUpdateEvent so the bag drawer, totals and cart count update as usual.
let cartEvents = null;
const eventsReady = import('@shopify/events').then((m) => (cartEvents = m)).catch(() => null);

const CART_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
const CHECK_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
const isColor = (n) => /^colou?r$/i.test(n || '');
const sized = (src, w) => { const u = String(src || '').replace(/^\/\//, 'https://'); return u + (u.includes('?') ? '&' : '?') + 'width=' + (w || 80); };
const esc = (s) => { const d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
const cache = {};
const details = async (handle) => {
  if (cache[handle]) return cache[handle];
  const r = await fetch('/products/' + handle + '.js'); if (!r.ok) throw new Error('load');
  return (cache[handle] = await r.json());
};

// money in the store's own format, from a Liquid-rendered sample ("1.234,56 kr" / "$1,234.56")
function money(cents) {
  const sample = (document.getElementById('lx-money') || {}).dataset ? document.getElementById('lx-money').dataset.sample : '';
  const m = (sample || '').match(/\d[\d.,\s  ']*\d/);
  if (!m) return (cents / 100).toFixed(2);
  const num = m[0];
  const dec = /[.,]\d{2}$/.test(num) ? num.slice(-3, -2) : '';
  const thou = (num.match(/[.,\s  ']/g) || []).find((c) => c !== dec) || '';
  const [whole, frac] = (cents / 100).toFixed(2).split('.');
  return sample.replace(num, whole.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (dec ? dec + frac : ''));
}

function decorate(card) {
  if (card.dataset.lxAdd) return;
  const gallery = card.querySelector('.card-gallery'); const link = card.querySelector('a[href*="/products/"]');
  if (!gallery || !link) return;
  const m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); if (!m) return;
  card.dataset.lxAdd = '1';
  const btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'lx-add'; btn.dataset.handle = m[1]; btn.setAttribute('aria-label', 'Add to bag'); btn.innerHTML = CART_ICON;
  gallery.appendChild(btn);
}
const scan = (root) => (root || document).querySelectorAll('product-card').forEach(decorate);

async function add(source, variantId, productId, done) {
  await eventsReady;
  const E = cartEvents && cartEvents.CartLinesUpdateEvent;
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const deferred = E ? E.createPromise() : null;
  if (E) source.dispatchEvent(new E({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }) });
    const j = await r.json();
    if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add this item.');
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    if (E) deferred.resolve({ cart: E.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'luxe-card-add', sourceId: 'luxe-card-add', itemCount: 1, productId: String(productId), sections: j.sections, didError: false } });
    else window.location.href = '/cart';
    done(null);
  } catch (err) { if (deferred) deferred.reject(err); done(err); }
}

function flash(btn) { btn.classList.add('is-done'); btn.innerHTML = CHECK_ICON; setTimeout(() => { btn.classList.remove('is-done'); btn.innerHTML = CART_ICON; }, 1600); }

function openModal(btn, p) {
  document.querySelectorAll('dialog.lx-modal').forEach((d) => d.remove());
  const dlg = document.createElement('dialog'); dlg.className = 'lx-modal';
  const imgs = p.images && p.images.length ? p.images : [];
  const firstVariant = p.variants.find((v) => v.available) || p.variants[0];
  const startImg = (firstVariant.featured_image && firstVariant.featured_image.src) || imgs[0] || '';
  dlg.innerHTML =
    '<button type="button" class="lx-m-x" aria-label="Close">&times;</button>' +
    '<div class="lx-m-media"><img class="lx-m-main" alt="' + esc(p.title) + '" src="' + esc(sized(startImg, 900)) + '">' +
    (imgs.length > 1 ? '<div class="lx-m-thumbs">' + imgs.slice(0, 10).map((s, i) => '<button type="button" class="lx-m-thumb" data-src="' + esc(s) + '" aria-label="Image ' + (i + 1) + '"><img alt="" src="' + esc(sized(s, 120)) + '"></button>').join('') + '</div>' : '') + '</div>' +
    '<div class="lx-m-info"><h3 class="lx-m-title">' + esc(p.title) + '</h3><p class="lx-m-price"></p><div class="lx-m-opts"></div>' +
    '<button type="button" class="lx-go" disabled>Add to bag</button><p class="lx-msg"></p>' +
    '<a class="lx-m-more" href="/products/' + esc(p.handle) + '">View full details</a></div>';
  document.body.appendChild(dlg);
  const main = dlg.querySelector('.lx-m-main'), priceEl = dlg.querySelector('.lx-m-price'), optsEl = dlg.querySelector('.lx-m-opts');
  const go = dlg.querySelector('.lx-go'), msg = dlg.querySelector('.lx-msg');
  const setMain = (src) => { if (src && main.getAttribute('data-cur') !== src) { main.setAttribute('data-cur', src); main.src = sized(src, 900); } };
  setMain(startImg);
  const chosen = p.options.map(() => ''), groups = [];
  let vid = null;
  const match = (vals) => p.variants.filter((v) => vals.every((s, i) => !s || v['option' + (i + 1)] === s));
  const showPrice = (v) => {
    const x = v || firstVariant;
    priceEl.innerHTML = (x.compare_at_price && x.compare_at_price > x.price ? '<s>' + money(x.compare_at_price) + '</s> ' : '') + money(x.price);
  };
  const refresh = () => {
    groups.forEach((g, i) => [...g.children].forEach((b) => {
      const test = chosen.slice(); test[i] = b.dataset.v;
      const ok = match(test).some((v) => v.available);
      b.classList.toggle('is-on', chosen[i] === b.dataset.v);
      if (b.classList.contains('lx-pill')) b.disabled = !ok; else b.style.opacity = ok ? '' : '.35';
    }));
    // the main image follows the selected colour (first variant with that colour that has its own image)
    p.options.forEach((op, i) => {
      if (isColor(op.name) && chosen[i]) {
        const vv = p.variants.find((v) => v['option' + (i + 1)] === chosen[i] && v.featured_image);
        if (vv) setMain(vv.featured_image.src);
      }
    });
    if (!chosen.every(Boolean)) { go.disabled = true; vid = null; msg.textContent = ''; showPrice(match(chosen)[0]); return; }
    const m = match(chosen)[0];
    showPrice(m);
    if (m && m.featured_image) setMain(m.featured_image.src);
    if (!m || !m.available) { go.disabled = true; vid = null; msg.textContent = m ? 'Sold out' : 'Unavailable'; return; }
    msg.textContent = ''; vid = m.id; go.disabled = false;
  };
  p.options.forEach((op, i) => {
    if (op.values.length === 1) { chosen[i] = op.values[0]; groups.push(document.createElement('div')); return; }
    const lbl = document.createElement('p'); lbl.className = 'lx-lbl';
    const row = document.createElement('div'); row.className = 'lx-row'; groups.push(row);
    const setLbl = () => { lbl.innerHTML = esc(op.name) + (chosen[i] ? ': <b>' + esc(chosen[i]) + '</b>' : ''); };
    setLbl();
    op.values.forEach((val) => {
      const b = document.createElement('button'); b.type = 'button'; b.dataset.v = val; b.title = val;
      const vv = isColor(op.name) && p.variants.find((v) => v['option' + (i + 1)] === val && v.featured_image);
      if (vv) { b.className = 'lx-sw'; b.style.backgroundImage = 'url(' + sized(vv.featured_image.src, 100) + ')'; b.setAttribute('aria-label', val); }
      else { b.className = 'lx-pill'; b.textContent = val; }
      b.onclick = () => { chosen[i] = chosen[i] === val ? '' : val; setLbl(); refresh(); };
      row.appendChild(b);
    });
    optsEl.append(lbl, row);
  });
  dlg.querySelectorAll('.lx-m-thumb').forEach((t) => { t.onclick = () => setMain(t.dataset.src); });
  go.onclick = () => {
    if (!vid) return; go.disabled = true; go.textContent = 'Adding…';
    add(dlg, vid, p.id, (err) => {
      if (err) { go.disabled = false; go.textContent = 'Add to bag'; msg.textContent = err.message; return; }
      dlg.close(); flash(btn);
    });
  };
  dlg.querySelector('.lx-m-x').onclick = () => dlg.close();
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); }); // backdrop click
  dlg.addEventListener('close', () => dlg.remove());
  showPrice(); refresh();
  dlg.showModal();
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.lx-add');
  if (!btn) return;
  e.preventDefault(); e.stopPropagation();
  btn.classList.add('is-busy');
  try {
    const p = await details(btn.dataset.handle);
    const needsChoice = p.variants.length > 1 && p.options.some((o) => o.values.length > 1);
    if (!needsChoice) {
      const v = p.variants.find((x) => x.available);
      if (!v) { btn.title = 'Sold out'; return; }
      add(btn, v.id, p.id, (err) => { if (!err) flash(btn); });
    } else openModal(btn, p);
  } catch (err) { /* leave the button as is */ }
  finally { btn.classList.remove('is-busy'); }
}, true);

scan();
new MutationObserver((muts) => { if (muts.some((m) => m.addedNodes.length)) scan(); }).observe(document.body, { childList: true, subtree: true });
